import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wrm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("wrm_token");
      localStorage.removeItem("wrm_user");
      if (!window.location.pathname.includes("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

/**
 * Normalize any API error into a human-readable string.
 * Handles FastAPI 422 payloads where `detail` is an array of Pydantic
 * ValidationError objects (each with `{type, loc, msg, input, url}`).
 */
export function extractError(err, fallback = "Une erreur est survenue") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (!d) return "";
        if (typeof d === "string") return d;
        const loc = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
        return loc ? `${loc}: ${d.msg}` : d.msg || JSON.stringify(d);
      })
      .filter(Boolean)
      .join(" • ") || fallback;
  }
  if (typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return fallback;
}

